import React from "react"
import Selectbox from "./Selectbox"
import NumberInput from "./NumberInput"

export default class DateInput extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="DateInput">
				<div className="row">
					<div className="col-sm-4">
						<Selectbox placeholder="Month" value="" options={this.props.months} />
					</div>
					<div className="col-sm-4">
						<NumberInput name="day" placeholder="Day" onChange={this.onChange} />
					</div>
					<div className="col-sm-4">
						<NumberInput name="year" placeholder="Year" onChange={this.onChange} />
					</div>
				</div>
			</div>
		);	
	}

}